import Client from '@/hosted_fields/common/connection/client';
import BaseFactory from '@/hosted_fields/component/fields/base-factory';
import CardFormatter from '@/hosted_fields/component/card-formatter';
import {MessageData} from '@/hosted_fields/common/types';

export default class CardExpiry extends BaseFactory {
  constructor(client: Client, data: MessageData) {
    super(client, data);
  }

  // @override
  addListeners(id: string) {
    super.addListeners(id);
    let el = document.getElementById(id);
    if (el) CardFormatter.formatCardExpiry(el);
  }

  getValue() {
    const id = this.inputElement.id;
    let incoming = super.getValue();
    incoming[id].value = incoming[id].value.replace(/ /g, '');
    return incoming;
  }
}
